import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // Load from localStorage on mount
  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (savedToken && savedUser) {
      setToken(savedToken);
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = (tokenValue, userData) => {
    localStorage.setItem('token', tokenValue);
    localStorage.setItem('user', JSON.stringify(userData));
    setToken(tokenValue);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  const updateUser = (userData) => {
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  // Check if user has a specific permission
  const hasPermission = (moduleName, action) => {
    if (!user) return false;
    if (user.role === 'superadmin') return true;
    if (!user.permissions || !user.permissions[moduleName]) return false;
    return user.permissions[moduleName][action] === true;
  };

  // Check if user can view a module (for nav visibility)
  const canView = (moduleName) => hasPermission(moduleName, 'view');

  const isSuperAdmin = () => user && user.role === 'superadmin';

  return (
    <AuthContext.Provider value={{
      user, token, loading,
      login, logout, updateUser,
      hasPermission, canView, isSuperAdmin,
      isAuthenticated: !!token
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
